import { AssetRegistersContextMenu } from "../register-actions/register-actions.runtime"
import { EditRegisterDescriptionMenuItem } from "./edit-register-description-menu-item"

AssetRegistersContextMenu.plug(<EditRegisterDescriptionMenuItem priority={20} />)
